import { render } from "./App.vue?vue&type=template&id=1d6c0b73"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1d6c0b73&lang=css"

import exportComponent from "C:\\development\\vueproject\\test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__